<div class="container-fluid">
  <div
    class="bg-image text-white d-flex align-items-end justify-content-between p-md-5 row"
  >
    <div class="col-md-6">
      <h1 class="title fw-light">
        Universidad del Deporte del Estado de Puebla
      </h1>
      <h3 class="fw-light">UDEP</h3>
    </div>

    <div class="col-md-6 d-flex overflow-auto">
      <div class="d-flex gap-2 pb-2">
        @for (announcement of announcements; track announcement.id) {
          <div
            class="card bg-secondary bg-opacity-50"
            style="height: 250px; width: 150px"
          >
            <img
              [src]="announcement.image_url"
              class="card-img opacity-25 object-fit-cover"
              style="object-position: bottom right"
              height="380"
              alt=""
            />
            <div
              class="card-img-overlay d-flex flex-column justify-content-end p-2"
            >
              <h6 class="text-white">{{ announcement.title }}</h6>
              @if (announcement.is_active) {
                <a
                  [routerLink]="['/convocatoria', announcement.id]"
                  style="font-size: small"
                  class="text-white"
                >
                  Ir a convocatoria
                </a>
              }
            </div>
          </div>
        } @empty {
          @if (loadingAnnouncements) {
            @for (placeholder of [1, 2, 3, 4, 5, 6]; track placeholder) {
              <div
                class="card bg-secondary placeholder-glow bg-opacity-10"
                style="width: 150px"
              >
                <span class="placeholder w-100" style="height: 250px"></span>
              </div>
            }
          } @else {
            <h6>No se encontraron convocatorias</h6>
          }
        }
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div
    class="row p-3 p-md-5 justify-content-center"
    style="background-color: #fffdf5"
  >
    <div class="col-md-6 px-md-5" style="text-align: justify">
      <h1 class="mb-5">La UDEP</h1>

      <div class="square mb-2"></div>

      <h5>Actitud Deportiva</h5>

      <p class="text-body-secondary">
        Es nuestro programa de activación física y motivación, dirigido a niñas,
        niños y adolescentes de secundaria. Promovemos la práctica deportiva:
        sembramos valores, actitud positiva y trabajo en equipo.
      </p>
      <p class="text-body-secondary">
        A través de dinámicas físicas, juegos colaborativos y ejercicios de
        liderazgo, los jóvenes descubren que el deporte es más que una
        actividad: es una forma de vida.
      </p>

      <div class="square mb-2 mt-4"></div>

      <h5>Aférrate a Tu Sueño</h5>

      <p class="text-body-secondary">
        Es un taller vivencial para estudiantes de secundaria y preparatoria que
        enfrentan decisiones sobre su futuro. Es una experiencia práctica,
        emotiva y reflexiva que conecta a cada joven con su historia, sus miedos
        y, sobre todo, con sus sueños.
      </p>
      <p class="text-body-secondary">
        Los participantes enfrentan el reto más importante: aferrarse a lo que
        los hace vibrar. No les damos respuestas: les damos herramientas para
        buscar las suyas
      </p>

      <div class="square mb-2 mt-4"></div>

      <h5>Tryouts UDEP: El ojo clínico del Chelís</h5>

      <p class="text-body-secondary">
        Para quienes ya forman parte de equipos deportivos en preparatorias,
        Tryouts UDEP es una puerta de entrada a un nuevo nivel a jóvenes que
        aspiran a formar parte de los Equipos Representativos de nuestra
        universidad.
      </p>
      <p class="text-body-secondary">
        Guiados por especialistas y con el respaldo de “el ojo clínico del
        Chelís”, no solo medimos velocidad, fuerza o técnica: pero corazón,
        compromiso y visión de futuro como deportistas integrales y futuros
        profesionales con valores.
      </p>
    </div>

    <div
      class="col-md-6 d-flex flex-column px-md-5"
      style="text-align: justify"
    >
      <p class="text-body-secondary mb-5">
        En la Universidad del Deporte del Estado de Puebla creemos que formar
        seres humanos a través del deporte comienza antes del aula. Por eso,
        impulsamos
        <strong>3 grandes acciones</strong>
        que conectan nuestra visión con la niñez y juventud poblana, sembrando
        el carácter, la disciplina y los sueños que forjarán a las próximas
        generaciones.
      </p>

      <div
        class="position-relative d-inline-block my-4 custom-img-wrapper h-100"
      >
        <div class="position-absolute bg-shape w-100 h-75"></div>
        <img
          src="/assets/img/home_image.png"
          class="img-fluid object-fit-cover position-relative z-1 h-100"
          alt=""
        />
      </div>
    </div>
  </div>
</div>

<div class="bg-body mb-4 mb-md-0">
  <h2 class="text-center pt-3 mb-4">Nuestros programas</h2>

  <div class="d-flex gap-2 align-items-center justify-content-center">
    <a routerLink="/programas/licenciaturas">
      <div class="card text-bg-dark">
        <img
          src="/assets/img/home_image_2.png"
          class="card-img opacity-50 object-fit-cover"
          height="380"
          alt=""
        />
        <div
          class="card-img-overlay d-flex flex-column justify-content-end align-items-start p-4"
        >
          <h5>Licenciaturas</h5>
          <p class="card-text text-white-50">
            Planes de estudio innovadores en áreas del deporte, relevantes para
            la industria deportiva en México y específicamente Puebla.
          </p>
        </div>
      </div>
    </a>
  </div>
</div>

<div class="container bg-body p-md-5">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <button class="btn btn-primary" routerLink="/articulos">Ver todos</button>

    <h1>Nuestros artículos</h1>
  </div>

  <div class="row g-3">
    @for (article of articles; track article) {
      <a [routerLink]="['/articulo', article.id]" class="col-md-3">
        <div class="card text-bg-dark" style="min-height: 300px">
          <img
            [src]="article.image_url"
            class="card-img object-fit-cover"
            height="180"
            alt=""
          />
          <div class="p-2">
            <h5 class="card-title">{{ article.title }}</h5>
            <p class="card-text">
              <i class="bi bi-clock"></i>
              {{ article.date | date: 'dd/MM/yyyy' }}
            </p>
          </div>
        </div>
      </a>
    } @empty {
      @if (loadingArticles) {
        @for (placeholder of [1, 2, 3, 4]; track placeholder) {
          <div class="col-md-3 placeholder-glow">
            <span class="placeholder w-100" style="height: 250px"></span>
          </div>
        }
      } @else {
        <h6>No se encontraron datos de artículos</h6>
      }
    }
  </div>

  <h1 class="my-3">Categorías</h1>

  <div class="row g-2">
    @for (category of categories; track category) {
      <a
        routerLink="/articulos/"
        [queryParams]="{ categoria: category.id }"
        class="col-md-4"
      >
        <div class="card text-bg-dark p-2">
          <h5 class="card-title mt-4">{{ category.name }}</h5>
          <p class="card-text">
            @if (category.quantityItems) {
              {{ category.quantityItems }}
              {{ category.quantityItems > 1 ? 'artículos' : 'artículo' }}
            }
          </p>
        </div>
      </a>
    } @empty {
      @if (loadingCategories) {
        @for (placeholder of [1, 2, 3]; track placeholder) {
          <div class="col-md-4 placeholder-glow mb-2">
            <span class="placeholder w-100" style="height: 100px"></span>
          </div>
        }
      } @else {
        <h6>No se encontraron datos de categorías</h6>
      }
    }
  </div>
</div>

@if (album) {
  <div class="position-relative my-5" style="height: 500px">
    @if (album.photos) {
      <img
        [src]="album.photos[0].image_url"
        alt=""
        height="500"
        class="object-fit-cover position-absolute w-100"
      />
    }

    <div class="bg-image-3 w-100"></div>

    <div
      class="position-absolute top-50 start-0 translate-middle-y text-end p-5"
    >
      <h1 class="display-1 text-white">
        {{ album.title }}
      </h1>
      <a [routerLink]="['/album', album.title]" class="text-white">
        Ver galería
      </a>
    </div>

    <div
      class="d-none d-md-flex gap-3 justify-content-center position-absolute top-100 start-50 translate-middle"
    >
      @for (photo of album.photos; track photo.id) {
        <img
          [src]="photo.image_url"
          class="cursor-zoom"
          data-bs-toggle="modal"
          [attr.data-bs-target]="'#imageModal' + $index"
          [alt]="photo.caption"
          width="120"
        />
      }
    </div>
  </div>

  @for (photo of album.photos; track photo.id) {
    <div
      class="modal fade"
      [id]="'imageModal' + $index"
      tabindex="-1"
      [attr.aria-labelledby]="'imageModalLabel' + $index"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" [id]="'imageModalLabel' + $index">
              Imagen {{ $index + 1 }}
            </h1>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <img
              [src]="photo.image_url"
              class="w-100 rounded"
              [alt]="photo.caption"
            />
          </div>
        </div>
      </div>
    </div>
  }
}